import React from 'react';
import { PieChart as RechartsPieChart, Pie, Cell, ResponsiveContainer, Tooltip } from 'recharts';
interface PieChartProps {
  data: any[];
  dataKey: string;
  nameKey: string;
  colors?: string[];
  donut?: boolean;
}
export const PieChart: React.FC<PieChartProps> = ({
  data,
  dataKey,
  nameKey,
  colors = ['#2563eb', '#60a5fa', '#93c5fd', '#bfdbfe', '#dbeafe'],
  donut = true
}) => {
  return <ResponsiveContainer width="100%" height={300} data-id="element-25">
      <RechartsPieChart data-id="element-26">
        <Pie data={data} cx="50%" cy="50%" labelLine={false} outerRadius={80} innerRadius={donut ? 60 : 0} fill="#8884d8" dataKey={dataKey} nameKey={nameKey} data-id="element-27">
          {data.map((entry, index) => <Cell key={`cell-${index}`} fill={colors[index % colors.length]} data-id="element-28" />)}
        </Pie>
        <Tooltip data-id="element-29" />
      </RechartsPieChart>
    </ResponsiveContainer>;
};